import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { CreditDialogComponent } from '../../shared/components/credits-dialog/credits-dialog.component';

export interface ManagedAccount {
  email: string;
  organization: string;
  role: string;
  plan: string;
  status: string;
  user?: any;
}

@Component({
  selector: 'app-account-management-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatButtonModule
  ],
  template: `
    <section class="tevuna-account-modal__content">
      <header class="tevuna-account-modal__head">
        <div>
          <p class="tevuna-account-modal__eyebrow">Account administration</p>
          <h2>{{ data.email }}</h2>
        </div>
        <button class="tevuna-account-modal__close" type="button" aria-label="Close account administration" (click)="close()">×</button>
      </header>
      <form [formGroup]="form" class="tevuna-account-modal__body">
        <div class="tevuna-account-modal__settings-grid">
          <label class="tevuna-account-modal__field"><span>Organization</span><input class="tevuna-account-modal__input" formControlName="organization"></label>
          <label class="tevuna-account-modal__field"><span>Role</span><select class="tevuna-account-modal__input" formControlName="role"><option value="Admin">Admin</option><option value="Analyst">Analyst</option><option value="Reviewer">Reviewer</option><option value="Viewer">Viewer</option></select></label>
          <label class="tevuna-account-modal__field"><span>Plan</span><select class="tevuna-account-modal__input" formControlName="plan"><option value="Maritime Unlimited">Maritime Unlimited</option></select></label>
          <label class="tevuna-account-modal__field"><span>Status</span><select class="tevuna-account-modal__input" formControlName="status"><option value="Active">Active</option><option value="Suspended">Suspended</option><option value="Invited">Invited</option></select></label>
        </div>
        <div class="tevuna-account-modal__actions">
          <button mat-stroked-button type="button" (click)="manageCredits()" [disabled]="!data.user">Manage credits</button>
          <button class="tevuna-account-modal__save" type="button" disabled>Save account</button>
        </div>
      </form>
    </section>
  `,
})
export class AccountManagementDialogComponent {
  readonly form = new FormGroup({
    organization: new FormControl(this.data.organization, { nonNullable: true }),
    role: new FormControl(this.data.role, { nonNullable: true }),
    plan: new FormControl(this.data.plan, { nonNullable: true }),
    status: new FormControl(this.data.status, { nonNullable: true })
  });

  constructor(
    private readonly dialogRef: MatDialogRef<AccountManagementDialogComponent>,
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) readonly data: ManagedAccount
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  manageCredits(): void {
    if (!this.data.user) return;
    this.dialog.open(CreditDialogComponent, { width: '1000px', height: '500px', data: { entity: this.data.user, entityType: 'user' } });
  }
}
